import React from 'react'
import './progress-stepper.scss'

type Step = {
  label: string
}

type ProgressStepperProps = {
  steps: Step[]
  currentStepIndex: number
}

export const ProgressStepper: React.FC<ProgressStepperProps> = ({ steps, currentStepIndex }) => {
  return (
    <nav className="stepper" role="navigation" aria-label="Reservation progress">
      {steps.map((step, index) => {
        const isCompleted = index < currentStepIndex
        const isActive = index === currentStepIndex

        return (
          <div key={index} className="step-container">
            <div className={`label ${isCompleted ? 'completed' : isActive ? 'active' : ''}`}>
              {step.label}
            </div>

            <div className={`circle ${isCompleted ? 'completed' : isActive ? 'active' : ''}`} />
            {index < steps.length - 1 && (
              <div className={`line ${isCompleted ? 'completed' : ''}`} />
            )}
          </div>
        )
      })}
    </nav>
  )
}
